module.exports = __webpack_public_path__ + "static/media/users-crown.cfb17841.svg";